import { useMemo, useState } from "react";
import { UsersThree } from "@phosphor-icons/react";
import { toast } from "sonner";

import { api, formatApiError } from "@/lib/api";

export default function BatchBuilder({ courses, trainers, centers = [], onCreated }) {
  const [name, setName] = useState("");
  const [courseId, setCourseId] = useState("");
  const [trainerId, setTrainerId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [capacity, setCapacity] = useState("30");
  const [centerId, setCenterId] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const selectedCourse = courses.find((course) => course.id === courseId);
  const eligibleTrainers = useMemo(() => {
    if (!selectedCourse) return [];
    return trainers.filter((trainer) => (
      selectedCourse.trainer_id === trainer.id
      || (selectedCourse.trainer_ids || []).includes(trainer.id)
    ) && trainer.center_id === centerId);
  }, [selectedCourse, trainers, centerId]);

  const submit = async (event) => {
    event.preventDefault();
    setIsSaving(true);
    try {
      await api.post("/lms/batches", {
        name,
        course_id: courseId,
        trainer_id: trainerId,
        center_id: centerId,
        start_date: startDate,
        end_date: endDate,
        capacity: Number(capacity),
      });
      setName("");
      setCourseId("");
      setTrainerId("");
      setStartDate("");
      setEndDate("");
      setCapacity("30");
      setCenterId("");
      toast.success("Batch created and mapped to its trainer");
      onCreated();
    } catch (error) {
      toast.error(formatApiError(error));
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <form className="person-builder batch-builder" onSubmit={submit} data-testid="create-batch-form">
      <div className="builder-heading"><p className="eyebrow">New batch</p><h3>Map a course and trainer</h3></div>
      <label htmlFor="batch-name">Batch name</label>
      <input id="batch-name" value={name} onChange={(event) => setName(event.target.value)} required data-testid="batch-name-input" />
      <label htmlFor="batch-course">Course</label>
      <select id="batch-course" value={courseId} onChange={(event) => { setCourseId(event.target.value); setTrainerId(""); }} required data-testid="batch-course-select"><option value="">Select course</option>{courses.map((course) => <option value={course.id} key={course.id}>{course.title}</option>)}</select>
      <label htmlFor="batch-center">Training center</label>
      <select id="batch-center" value={centerId} onChange={(event) => { setCenterId(event.target.value); setTrainerId(""); }} required data-testid="batch-center-select"><option value="">Select training center</option>{centers.map((center) => <option value={center.id} key={center.id}>{center.name}</option>)}</select>
      <label htmlFor="batch-trainer">Mapped trainer</label>
      <select id="batch-trainer" value={trainerId} onChange={(event) => setTrainerId(event.target.value)} required disabled={!courseId || !centerId} data-testid="batch-trainer-select"><option value="">Select trainer</option>{eligibleTrainers.map((trainer) => <option value={trainer.id} key={trainer.id}>{trainer.name}</option>)}</select>
      <label htmlFor="batch-start-date">Start date</label>
      <input id="batch-start-date" type="date" value={startDate} onChange={(event) => setStartDate(event.target.value)} required data-testid="batch-start-date-input" />
      <label htmlFor="batch-end-date">End date</label>
      <input id="batch-end-date" type="date" value={endDate} min={startDate} onChange={(event) => setEndDate(event.target.value)} required data-testid="batch-end-date-input" />
      <label htmlFor="batch-capacity">Capacity</label>
      <input id="batch-capacity" type="number" min="1" max="10000" value={capacity} onChange={(event) => setCapacity(event.target.value)} required data-testid="batch-capacity-input" />
      <button className="primary-button" disabled={isSaving} data-testid="create-batch-submit-button"><UsersThree aria-hidden="true" size={19} />{isSaving ? "Creating" : "Create batch"}</button>
    </form>
  );
}